import { render, staticRenderFns } from "./yiFujinE.vue?vue&type=template&id=4f308efe&scoped=true&"
import script from "./yiFujinE.vue?vue&type=script&lang=js&"
export * from "./yiFujinE.vue?vue&type=script&lang=js&"
import style0 from "./yiFujinE.vue?vue&type=style&index=0&id=4f308efe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f308efe",
  null
  
)

export default component.exports